import { SxStyle } from '../../../types/style';

const contentBox: SxStyle = {
    width: '100%',
    padding: 2,
    minHeight: 'calc(100vh - 55px)'
};

const contentBoxContainer1GridItemBox: SxStyle = {
    display: 'flex', 
    justifyContent: 'space-between', 
    alignItems: 'center'
}

const contentBoxContainer1GridItemBoxTypography: SxStyle = {
    fontWeight: 700
}

const contentBoxContainer1GridItemBoxBoxButton: SxStyle = {
    marginRight: '8px'
}

const contentBoxContainer2PaperGridItem1Typography: SxStyle = {
    fontWeight: 700
}

const contentBoxContainer2PaperGridItem2Box: SxStyle = {
    display: 'flex', 
    justifyContent: 'space-between', 
    alignItems: 'center'
}

const contentBoxContainer2PaperGridItem3Box: SxStyle = {
    height: 'auto',
    width: '100%',
}

// dialog
const dialogDialogTitle: SxStyle = {
    fontWeight: 700
}

// columns datagrid
const dataGridBox: SxStyle = {
    width: '50px', 
    height: '30px', 
    borderRadius: '5px', 
    marginRight: '14px', 
    marginLeft: '14px'
}

const dataGridBox2: SxStyle = {
    width: '100%',
    display: 'flex',
    justifyContent: 'center',
    alignItems: 'center'
};

const dataGridBox2AvatarGroup: SxStyle = {
    marginRight: '16px'
};

const dataGridBox2AvatarGroupAvatar: SxStyle = {
    width: 32,
    height: 32
};

export const articleDetailStyle = {
    contentBox,
    contentBoxContainer1GridItemBox,
    contentBoxContainer1GridItemBoxTypography,
    contentBoxContainer1GridItemBoxBoxButton,
    contentBoxContainer2PaperGridItem1Typography,
    contentBoxContainer2PaperGridItem2Box,
    contentBoxContainer2PaperGridItem3Box,
    dialogDialogTitle,
    dataGridBox,
    dataGridBox2,
    dataGridBox2AvatarGroup,
    dataGridBox2AvatarGroupAvatar
};